import { useTranslation } from "react-i18next";

export const LANG_STORAGE_KEY = "atlas.lang";
export const APP_LANGS = ["en", "th"] as const;
export type AppLang = (typeof APP_LANGS)[number];

function normalize(lang: string): AppLang {
  return lang === "th" ? "th" : "en";
}

export function useLanguage(): [AppLang, (lang: AppLang) => void] {
  const { i18n } = useTranslation();
  const current = normalize(i18n.language);

  const setLanguage = (lang: AppLang): void => {
    void i18n.changeLanguage(lang);
    try {
      localStorage.setItem(LANG_STORAGE_KEY, lang);
    } catch {
      /* privacy mode */
    }
  };

  return [current, setLanguage];
}
